import { SidePanelDefaultMode } from 'presentation/screens/SearchHistoryScreen/components/SearchHistoryPanel/SearchHistorySidePanel/components/SidePanelDefaultMode'

export const SearchHistorySidePanel = () => (
  <SidePanelDefaultMode />
)
